//router before each 相关的业务
import utils from 'blue-utils';
import RouterNext from './router-next';
import { setTabBarSubmenuIndex } from '$components/bv-tab-bar';
import { bind } from '$assets/js/bind';
import { routerMeta } from '@router';
import { serverRedirect } from '$assets/js/redirect';

//main
export function routerBeforeEach(opts = {}) {
  const { router, beforeEach } = opts;
  const sess = window.sessionStorage;

  //存在重定向的不在走router beforeEach
  router.beforeEach((to, from, next) => {
    //设置子菜单的状态
    setTabBarSubmenuIndex({
      tabBarSubMenuStatus: -1
    });
    //设置路由标识
    routerMeta.setCurrentRouteID(to.meta.routeID);

    //实例化router next
    const routerNext = new RouterNext({
      to,
      from
    });

    routerNext.add([
      //检查重定向参数
      serverRedirect()
    ]);

    routerNext.add([
      //项目内使用的before each
      utils.hook(null, beforeEach, [to, from]),
      //公共的after hook
      routerBeforeHook({
        to,
        from
      })
    ]);

    //路由的下一跳状态，决定路由何去何从
    const nextStatue = routerNext.nextStatus();

    //next的状态
    if (RouterNext.preventRouterNext(nextStatue)) {
      next(nextStatue);
    } else {
      next();
    }

  });
}

//router after hook
export function routerBeforeHook(opts) {
  const routerNext = new RouterNext(opts);
  routerNext.add([
    //绑定相关（暂时不适用这套业务）
    bind(opts)
  ]);
  return routerNext.nextStatus();
}